import { render, staticRenderFns } from "./ItemGroupChip.vue?vue&type=template&id=0577446c&scoped=true&"
import script from "./ItemGroupChip.vue?vue&type=script&lang=ts&"
export * from "./ItemGroupChip.vue?vue&type=script&lang=ts&"
import style0 from "./ItemGroupChip.vue?vue&type=style&index=0&id=0577446c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0577446c",
  null
  
)

export default component.exports